import React, { Component } from "react";
import cx from "classnames";
import { addonTypes, addonDefaultProps } from "../../types";
import { LineBreaks, RawHTML } from "../common";
import styles from "./styles.less";

class Addon extends Component {
  onIncrement = () => {
    const { id, onIncrement } = this.props;
    onIncrement(id);
  };

  onDecrement = () => {
    const { id, onDecrement } = this.props;
    onDecrement(id);
  };

  render() {
    const {
      amount,
      name,
      description,
      imageURL,
      price,
      isRtl,
      defaultImageURL
    } = this.props;
    return (
      <div className={styles.addon}>
        <div className={styles.imageContainer}>
          <img
            className={styles.image}
            src={imageURL}
            alt={`${name} ${description}`}
            onError={defaultImageURL}
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={cx(styles.name, { [styles.rtl]: isRtl })}>
            <RawHTML html={name} />
          </div>
          <div>
            <LineBreaks
              className={cx(styles.description, { [styles.rtl]: isRtl })}
            >
              <RawHTML html={description} />
            </LineBreaks>
          </div>

          <div className={styles.buttonsWrapper}>
            <button
              className={cx(styles.btn, styles.minus)}
              onClick={this.onDecrement}
              onKeyDown={this.onDecrement}
            />
            <div className={styles.amount}>{amount}</div>
            <button
              className={cx(styles.btn, styles.plus)}
              onClick={this.onIncrement}
              onKeyDown={this.onIncrement}
            />
            <div className={styles.priceWrapper}>{price}</div>
          </div>
        </div>
      </div>
    );
  }
}

Addon.defaultProps = addonDefaultProps;

Addon.propTypes = addonTypes;

export default Addon;



// WEBPACK FOOTER //
// ./src/components/Addon/Addon.js